import { render, staticRenderFns } from "./BankPhone.vue?vue&type=template&id=2066d990&scoped=true&"
import script from "./BankPhone.vue?vue&type=script&lang=js&"
export * from "./BankPhone.vue?vue&type=script&lang=js&"
import style0 from "./BankPhone.vue?vue&type=style&index=0&id=2066d990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066d990",
  null
  
)

export default component.exports